interface PageWithCount {
    count: number;
}

// Пустая страница завершает подгрузку: при расхождении count с фактическим числом строк смещение
// иначе не сдвигается, и таблица зовёт fetchNextPage по кругу.
export function getNextOffsetPageParam<Page extends PageWithCount>(
    lastPage: Page,
    allPages: Page[],
    selectRows: (page: Page) => unknown[],
): number | undefined {
    if (selectRows(lastPage).length === 0) {
        return undefined;
    }

    const loaded = allPages.reduce((total, page) => total + selectRows(page).length, 0);

    return loaded < lastPage.count ? loaded : undefined;
}
